// src/menu/sections/pagesMenu.ts
import type { AppMenuEntry } from "../types";

export const PAGES_MENU: AppMenuEntry = {
  type: "group",
  key: "pages",
  label: "Pages",
  children: [
    {
      key: "hello",
      label: "Hello World",
      path: "/hello",
      componentKey: "helloWorld",
      icon: "question",
    },
  ],
};
